
import PropTypes from 'prop-types';

const Content = ({ children, style, ...props }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                gap: '24px',
                ...style
            }}
            {...props}
        >
            {children}
        </div>
    );
};

Content.propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
};

export default Content; 